import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceMembersRow } from "../workspaceMembersRow";
import { MemberActions } from "../MemberActions";
import { OrganizationActions } from "../OrganizationActions";
import { InviteActions } from "../InviteActions";

export const ActionsCell = memo(function ActionsCell({
    row,
}: CellContext<ViewTableFeatures, WorkspaceMembersRow, unknown>) {
    const data = row.original;

    return (
        <ViewTableCell captureClicks>
            {data.kind === "member" && <MemberActions member={data.member} />}
            {data.kind === "organization" && (
                <OrganizationActions organization={data.organization} />
            )}
            {data.kind === "invite" && <InviteActions invite={data.invite} />}
        </ViewTableCell>
    );
});
